<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Notifications",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            loading: true,
            title: "Notifications",
            items: [
               {
                  text: "Notifications",
                  active: true,
               },                   
            ],

            notifications: [],
            patients: [],

            doctors: [],

            notification: {
               id: "",
               title: "",
               description: "",
               type: "",
               doctor_id: '',
               patient_id: '',
            },

            doctor_id: '',           
            doctor_type: '',
            doctor_keyword: '',
            doctor_visible: false,

            patient_id: '',
            patient_type: '',
            patient_keyword: '',
            patient_visible: false,

            
            modal_title: "Add Notification",
            button_title: "Save",
            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,

            type: '',
            keyword: "",
            listing_length: 10,
            token: "",
            errors: {},
            
            delete: false,
            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchNotifications();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchNotifications(page_url = null) {

            this.getToken();
            let url = "api/admin/notification?keyword=" + this.keyword + "&limit=" + this.listing_length + "&type=" + this.type;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.notifications = responseData.notifications.data;
                  
                  this.pagination = responseData.notifications.links;
                  this.from = responseData.notifications.from;
                  this.to = responseData.notifications.to;
                  this.total = responseData.notifications.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         closeDoctorSearch() {
            this.doctor_visible = false;        
            this.doctor_keyword = '';
         },

         closePatientSearch() {
            this.patient_visible = false;       
            this.patient_keyword = '';
         },

         setDoctor() {
            this.doctor_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.doctor_visible = false;
         },

         setPatient() {
            this.patient_keyword = event.target.options[event.target.options.selectedIndex].label;
            this.patient_visible = false;
         },

         fetchDoctors() {  

            let url = "api/admin/consultations/getdoctors?keyword=" + this.doctor_keyword;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.doctors = responseData.doctors;
                  this.doctor_visible = true;
                   this.justOpened = true;
                     // Focus the input after DOM update
                     this.$nextTick(() => {
                        this.$refs.doctorInput?.focus();
                     });

                     // Reset the outside click block after a short delay
                     setTimeout(() => {
                        this.justOpened = false;
                     }, 300);
               })
               .catch((err) => console.log(err));
               
         },

         fetchPatients() { 
            let url = "api/admin/pharmacy/orders/getpatients?keyword=" + this.patient_keyword;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.patients = responseData.patients;
                  this.patient_visible = true;
                   this.justOpened = true;
                     // Focus the input after DOM update
                     this.$nextTick(() => {
                        this.$refs.patientInput?.focus();
                     });

                     // Reset the outside click block after a short delay
                     setTimeout(() => {
                        this.justOpened = false;
                     }, 300);
               })
               .catch((err) => console.log(err));
            
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         editNotification(notification) {
            this.edit = true;
            this.notification.id = notification.id;
            this.notification.title = notification.title;
            this.notification.description = notification.description;           
            this.notification.type = notification.type;
            this.doctor_type = 0;
            this.patient_type = 0;

            if (notification.user_id) {

               if(notification.type == 2) {
                  this.doctor_type = 1;
                  this.notification.doctor_id = notification.user_id;  
                  this.doctor_id = notification.user_id;            
                  this.doctor_keyword = notification.country_code + notification.mobile;
               } 

               if(notification.type == 3) {
                  this.patient_type = 1;
                  this.notification.patient_id = notification.user_id;  
                  this.patient_id = notification.user_id;            
                  this.patient_keyword = notification.country_code + notification.mobile;
               } 
               
            } else {
               this.notification.doctor_id = '';
               this.doctor_keyword = '';
               this.doctor_id = '';

               this.notification.patient_id = '';
               this.patient_keyword = '';
               this.patient_id = '';
            }
            
            this.errors = {};
            this.modal_title = "Edit Notification";
            this.button_title = "Update";
            this.showModal("notification-modal");
         },

         addNotification() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "api/admin/notification/add";
               this.active_page_url = null;

            } else {
               url = "api/admin/notification/edit";
               formData.append("notification_id", this.notification.id); 
            }         

            formData.append("title", this.notification.title); 
            formData.append("description", this.notification.description); 
            formData.append("type", this.notification.type); 

            if(this.notification.type == 1) {
               formData.append("user_id", ""); 

            } else {
               if(this.notification.type == 2) {
                  formData.append("user_id", this.doctor_id); 
               }
               if(this.notification.type == 3) {
                  formData.append("user_id", this.patient_id); 
               }
            }       
      
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('notification-modal');
                  this.fetchNotifications(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         clearForm() {
            this.edit = false;
            this.notification.id = "";
            this.notification.title = "";
            this.notification.description = "";
            this.notification.type = '';
            this.notification.doctor_id = '';
            this.notification.patient_id = '';
            this.doctor_keyword = '';
            this.patient_keyword = '';
            this.modal_title = "Add Notification";
            this.button_title = "Save";
            this.errors = {};

            this.doctor_id = '';
            this.doctor_type = '';
            this.doctor_keyword = '';

            this.patient_id = '';
            this.patient_type = '';
            this.patient_keyword = '';
         },

         deleteNotification(notification_id) {
            this.delete = false;
            this.$bvModal.msgBoxConfirm('Are you sure you want to delete this notification?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
            })
            .then(value => {
               this.delete = value
               if(this.delete){
                  this.getToken();           
            
                  const config = {
                     headers: {
                        "Content-type": "application/json",
                        "Accept": "application/json",
                        "Authorization": "Bearer " + this.token,
                     },
                  };
                  console.log(this.token);
                  let formData = new FormData();
                  formData.append("id", notification_id); 

                  // var formData = JSON.stringify({
                  //    "tv_show_id": tvshow_id
                  // });

                  let url = "api/admin/notification/delete";
                  this.$axios
                  .post(url, formData, config)
                  .then((response) => {
                        if (response.data.status) {
                           this.$swal("", response.data.message, "success");
                        } else {
                           this.$swal("", response.data.message, "error");
                        }
                        this.fetchNotifications(this.active_page_url);
                  })
                  .catch((error) => {
                     if (error.response) {
                        if (error.response.data.message) {
                           this.errors = error.response.data.message;
                           //console.log(this.errors);
                        } else {
                           this.$swal("", "Something went wrong", "error");
                        }
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  })
                  .finally(() => (this.loading = false));
               }
            })
            .catch(err => {
               console.log(err);
            })
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.notification-modal variant="primary" class="float-end">Add Notification</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchNotifications()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchNotifications()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="type" @change="fetchNotifications()">
                              <option value="">All</option>
                              <option value="1">All Users</option>
                              <option value="2">Doctors</option>
                              <option value="3">Patients</option>
                           </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">

                        <thead class="table-light">
                           <tr>
                              <th>Title</th>
                              <th>Notification</th>
                              <th>Type</th>
                              <th>User</th>
                              <th>Created On</th>
                              <th>Options</th>
                           </tr>
                        </thead>

                        <tbody v-if="Boolean(notifications.length)">
                           <tr v-for="(notification) in notifications" :key="notification.id">
                              <td>{{notification.title}}</td>
                              <td><p class="w-200px">{{notification.description}}</p></td>
                              <td>
                                 <p v-if="notification.type==1">All Users</p>
                                 <p v-if="notification.type==2">Doctors</p>
                                 <p v-if="notification.type==3">Patients</p>
                              </td>
                              <td>
                                 <span v-if="notification.user_id">
                                    <span v-if="notification.type==2 && notification.doctor">
                                       Dr. {{notification.doctor.doctor_name}}<br>
                                       {{notification.doctor.country_code}} {{notification.doctor.mobile}}
                                    </span>
                                    <span v-if="notification.type==3 && notification.patient">
                                       {{notification.patient.patient_name}}<br>
                                       {{notification.patient.country_code}} {{notification.patient.mobile}}
                                    </span><br>
                                    
                                 </span>

                              </td>
                              <td>{{notification.converted_created_at}}</td>
                              <td>                                
                                 <!-- <b-button v-if="!notification.booking_id" variant="primary" class="btn btn-sm me-2 mb-2" @click="editNotification(notification)">Edit</b-button> -->
                                 <b-button variant="danger" class="btn btn-sm me-2 mb-2" @click="deleteNotification(notification.id)">Delete</b-button>
                              </td>
                           </tr>
                        </tbody>

                        <tbody v-else>
                           <tr>
                              <td colspan="7" class="text-center">No notifications found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(notifications.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchNotifications(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&type=' + type )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="notification-modal" id="notification-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addNotification()">

                        <b-col md="12" class="form-group">
                           <label class="control-label">Title <span class="text-danger">*</span></label>
                           <b-form-input v-model="notification.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }"></b-form-input>

                           <div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>

                        </b-col>
                        

                        <b-col md="12" class="form-group">
                           <label class="control-label">Notification Type <span class="text-danger">*</span></label>
                           <select class="form-control" v-model="notification.type" v-bind:class="{ 'is-invalid': Boolean(errors.type) }">
                              <option value="">Select</option>
                              <option value="1">All Users</option>
                              <option value="2">Doctors</option>
                              <option value="3">Patients</option>
                           </select>

                           <div v-for="(val, index) in errors.type" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <b-col md="12" class="form-group" v-if="notification.type==2">
                           <label class="control-label">Notification for <span class="text-danger">*</span></label>
                                                            
                           <b-form-radio-group v-model="doctor_type" @change="doctor_id=''">
                              <div class="form-check-inline">
                                 <b-form-radio name="doctor_type"  :value="0">All Doctors</b-form-radio>   
                              </div>
                              <div class="form-check-inline">
                                 <b-form-radio name="doctor_type" :value="1">Specific Doctor</b-form-radio>
                              </div>
                           </b-form-radio-group>


                           <div class="search-select" v-show="doctor_type">
                              <span class="search-close" v-show="doctor_visible" @click="closeDoctorSearch"><i class="dripicons dripicons-cross"></i></span>
                                 
                              <b-form-input v-model="doctor_keyword" ref="doctorInput" @keyup="fetchDoctors()"  @click="fetchDoctors()" v-bind:class="{ 'is-invalid': Boolean(errors.doctor_id) }" autocomplete="off" placeholder="Search here..."></b-form-input>
                              <div v-for="(val, index) in errors.doctor_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                              </div>   
                              <b-form-select class="form-control" v-if="doctor_visible && Boolean(doctors.length)" v-model="doctor_id" :select-size="doctors.length < 10 ? (doctors.length <= 1 ? 2 : doctors.length) : 10" @change="setDoctor">
                                 <b-form-select-option v-for="doctor in doctors" :key="doctor.id" :value="doctor.id">{{doctor.country_code}} {{doctor.mobile}} | {{ doctor.name }}</b-form-select-option>
                              </b-form-select>

                              <b-form-select class="form-control" v-if="doctor_visible && !Boolean(doctors.length)" v-model="doctor_id" :select-size="2">                  
                                 <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                              </b-form-select>
                           </div>
                           
                           <div v-for="(val, index) in errors.user_id" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>

                        </b-col>

                        <b-col md="12" class="form-group" v-if="notification.type==3">
                           <label class="control-label">Notification for <span class="text-danger">*</span></label>
                                                            
                           <b-form-radio-group v-model="patient_type" @change="patient_id=''">
                              <div class="form-check-inline">
                                 <b-form-radio name="patient_type"  :value="0">All Patients</b-form-radio> 
                              </div>
                              <div class="form-check-inline">
                                 <b-form-radio name="patient_type" :value="1">Specific Patient</b-form-radio>
                              </div>
                           </b-form-radio-group>


                          <div class="search-select" v-show="patient_type">
                              <span class="search-close" v-show="patient_visible" @click="closePatientSearch"><i class="dripicons dripicons-cross"></i></span>

                              <b-form-input
                                 ref="patientInput"
                                 v-model="patient_keyword"
                                 @keyup="fetchPatients"
                                 @click="fetchPatients"
                                 :class="{ 'is-invalid': Boolean(errors.patient_id) }"
                                 autocomplete="off"
                                 placeholder="Search here..."
                              ></b-form-input>

                              <!-- Error messages and dropdown code -->

                              <div v-for="(val, index) in errors.patient_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                              </div>   
                              <b-form-select class="form-control" v-if="patient_visible && Boolean(patients.length)" v-model="patient_id" :select-size="patients.length < 10 ? (patients.length <= 1 ? 2 : patients.length) : 10" @change="setPatient">
                                 <b-form-select-option v-for="patient in patients" :key="patient.patient_id" :value="patient.patient_id">{{patient.country_code}} {{patient.mobile}} | {{ patient.name }} </b-form-select-option>
                              </b-form-select>

                              <b-form-select class="form-control" v-if="patient_visible && !Boolean(patients.length)" v-model="patient_id" :select-size="2">                  
                                 <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                              </b-form-select>
                           </div>
                           
                           <div v-for="(val, index) in errors.user_id" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>

                        </b-col>

                        <b-col md="12" class="form-group">
                           <label class="control-label">Description <span class="text-danger">*</span></label>
                           <textarea v-model="notification.description" class="form-control" rows="3" v-bind:class="{ 'is-invalid': Boolean(errors.description) }"></textarea>
                           
                           <div v-for="(val, index) in errors.description" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-col>

                        <!-- <b-col md="12">
                           <b-button type="submit" class="me-3" variant="primary">{{ button_title }}</b-button>
                           <b-button class="" variant="light" @click="hideModal('notification-modal')">Close</b-button>
                        </b-col> -->
                        <b-col md="12">
                           <div class="page-loader" v-if="!loading">
                              <b-button type="submit" class="me-3" variant="primary">{{ button_title }} </b-button>
                              
                              <b-button class="" variant="light" @click="hideModal('notification-modal')">Close</b-button>
                           </div> 

                           <div class="page-loader" v-else>
                              <img src="@/assets/images/preloaderspin.gif"/>
                           </div>

                        </b-col>
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
<style lang="scss" scoped>
   // $colors: #8CC271, #69BEEB, #F5AA39, #E9643B;
 
  .page-loader img {
   max-width: 30px;
  }
</style>

